var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"form-label"},[_vm._v("Points")]),_c('div',{staticClass:"vx-col"},[_c('vs-input-number',{staticStyle:{"width":"100px"},attrs:{"min":"1"},model:{value:(_vm.points),callback:function ($$v) {_vm.points=$$v},expression:"points"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }